/**
 * Loads the gift tab as soon as the page is interactive; the reward dialog
 * still opens only when requested by the visitor or a shareable deep link.
 */
import { lazy, Suspense, useEffect, useState } from "react";

const SignupPopup = lazy(() =>
  import("@/components/identity/SignupPopup").then((m) => ({ default: m.SignupPopup })),
);

export function LazySignupPopup() {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
  }, []);

  if (!load) return null;
  return (
    <Suspense fallback={null}>
      <SignupPopup />
    </Suspense>
  );
}
